 // Scripting to handle tabs interaction
(function($){

    $(".tab_content").hide();
    $(".tab_content:first").show();

    $("ul.tabs li").click(function() {

      $(".tab_content").hide();
      var activeTab = $(this).attr("rel");
      $("#"+activeTab).fadeIn();

      $("ul.tabs li").removeClass("active");
      $(this).addClass("active");
    });
    $(".tab_container").css("min-height", function(){
      return $(".tabs").outerHeight() + 50;
    });


  // Committess page
  $(".wp-block-baytek-toggle-expand-all").on( "click", function() {
        $(this).toggleClass("active");
        $(".wp-block-baytek-toggle").toggleClass("expanded");
  });


  //Content toggling on the Transportation dashboard
  $(document).on('click', '.content-toggle-wrap .toggle-trigger', function(e) {
    $(this).parents('.content-toggle-wrap').find('.toggleable').toggleClass('toggleable-hidden');
    $(this).parents('.content-toggle-wrap').find('.toggle-trigger').toggleClass('active');
  });

})(jQuery);
